import React from 'react';

const BlogHeroSection = () => {
    return (
      <section className="relative w-full h-[350px] md:h-[450px] flex items-center justify-center overflow-hidden mb-12 -mt-24">
        <img 
          src="https://i.pinimg.com/736x/1c/b6/37/1cb6371531afead31f7c0e4ccfe7fef4.jpg" 
          alt="Blog Hero Background" 
          className="absolute inset-0 w-full h-full object-cover brightness-[0.25]"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-transparent to-white/5"></div>
        <div className="relative z-10 text-center px-4 flex flex-col items-center justify-center pt-16">
          <div className="flex items-center justify-center gap-2 mb-4 tracking-[0.2em] text-xs font-bold text-purple-300 uppercase">
            <span>CONTEÚDO EXCLUSIVO</span>
          </div>
          <h1 className="text-4xl md:text-6xl font-black text-white mb-4 drop-shadow-xl tracking-tight">
            Blog <span className="text-transparent bg-clip-text bg-gradient-to-r from-purple-400 to-indigo-400">LUKOS</span>
          </h1>
          <p className="text-white/80 text-base md:text-xl font-medium max-w-2xl drop-shadow-md">
            Insights, tendências e novidades sobre tecnologia e gestão para revolucionar o seu negócio.
          </p>
        </div>
      </section>
    );
};

export default BlogHeroSection;
